// extracted by mini-css-extract-plugin
export default {"pagefooter":"Footer_pagefooter__7w+w1","footercopyright":"Footer_footercopyright__Xbrn+"};